import { BellIcon } from "@phosphor-icons/react"
import hkLogo from "@repo/assets/logos/hk-black.png"
import { Avatar, AvatarFallback } from "@repo/ui/components/avatar"
import { Button } from "@repo/ui/components/button"
import { Link } from "react-router"

import { ThemeToggle } from "@/components/theme-toggle"

export function AppHeader() {
  return (
    <header className="sticky top-0 z-30 border-b bg-background/80 pt-[env(safe-area-inset-top)] backdrop-blur-lg supports-[backdrop-filter]:bg-background/60">
      <div className="mx-auto flex h-14 max-w-md items-center justify-between px-4">
        <Link
          to="/"
          aria-label="Henry Klevor home"
          className="rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-ring/50"
        >
          <img
            src={hkLogo}
            alt="Henry Klevor"
            className="h-9 w-auto dark:invert"
          />
        </Link>
        <div className="flex items-center gap-1">
          <ThemeToggle />
          <Button
            variant="ghost"
            size="icon"
            className="relative"
            aria-label="Notifications"
          >
            <BellIcon className="size-6" aria-hidden />
            <span className="absolute top-2 right-2.5 size-2 rounded-full bg-primary ring-2 ring-background" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            aria-label="Profile"
            render={<Link to="/settings" />}
            nativeButton={false}
          >
            <Avatar>
              <AvatarFallback>HK</AvatarFallback>
            </Avatar>
          </Button>
        </div>
      </div>
    </header>
  )
}
